import { render, staticRenderFns } from "./ProductSectionCategory.vue?vue&type=template&id=1adbb9fd&scoped=true"
import script from "./ProductSectionCategory.vue?vue&type=script&lang=js"
export * from "./ProductSectionCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionCategory.vue?vue&type=style&index=0&id=1adbb9fd&prod&lang=scss"
import style1 from "./ProductSectionCategory.vue?vue&type=style&index=1&id=1adbb9fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adbb9fd",
  null
  
)

export default component.exports